import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";

import { AuthGuard } from "./core/services";
import { RoleGuard } from "./core/services/role-guard.service";
import { PageLayoutComponent } from "./core/layouts/page-layout.component";

const routes: Routes = [
  {
    path: "",
    component: PageLayoutComponent,
    canActivate: [AuthGuard, RoleGuard],
    canLoad: [AuthGuard, RoleGuard],
    data: { roles: ["genericoRol"] },
    children: [
      {
        path: "documentacion",
        loadChildren:
          "app/documentation/documentation.module#DocumentationModule",
        canActivate: [AuthGuard, RoleGuard],
        canActivateChild: [AuthGuard, RoleGuard],
        canLoad: [AuthGuard, RoleGuard],
        data: { roles: ["genericoRol"] },
      },
      {
        path: "denuncia",
        loadChildren: "app/complaint/complaint.module#ComplaintModule",
        canActivate: [AuthGuard, RoleGuard],
        canActivateChild: [AuthGuard, RoleGuard],
        canLoad: [AuthGuard, RoleGuard],
        data: { roles: ["denunciaRol"] },
      },
      {
        path: "datos",
        loadChildren: "app/my-data/my-data.module#MyDataModule",
        canActivate: [AuthGuard, RoleGuard],
        canActivateChild: [AuthGuard, RoleGuard],
        canLoad: [AuthGuard, RoleGuard],
        data: { roles: ["datosRol"] },
      },
      {
        path: "unidades",
        loadChildren:
          "app/insured-unities/insured-unities.module#MyUnitiesModule",
        canActivate: [AuthGuard, RoleGuard],
        canActivateChild: [AuthGuard, RoleGuard],
        canLoad: [AuthGuard, RoleGuard],
        data: { roles: ["unidadesRol"] },
      },
      {
        path: "conductor",
        loadChildren: "app/driver/driver.module#DriverModule",
        canActivate: [AuthGuard, RoleGuard],
        canActivateChild: [AuthGuard, RoleGuard],
        canLoad: [AuthGuard, RoleGuard],
        data: { roles: ["conductorRol"] },
      },
      {
        path: "usuario",
        loadChildren:
          "app/user-admistrator/user-admistrator.module#UserAdministrationModule",
        canActivate: [AuthGuard, RoleGuard],
        canActivateChild: [AuthGuard, RoleGuard],
        canLoad: [AuthGuard, RoleGuard],
        data: { roles: ["usuarioRol"] },
      },
      {
        path: "index",
        loadChildren: "app/initial/initial.module#InitialModule",
        canActivate: [AuthGuard, RoleGuard],
        canActivateChild: [AuthGuard, RoleGuard],
        canLoad: [AuthGuard, RoleGuard],
        data: { roles: ["genericoRol"] },
      },
      {
        path: "claim",
        loadChildren: "app/claim/claim.module#ClaimModule",
        canActivate: [AuthGuard, RoleGuard],
        canActivateChild: [AuthGuard, RoleGuard],
        canLoad: [AuthGuard, RoleGuard],
        data: { roles: ["genericoRol"] },
      },
      {
        path: "letter",
        loadChildren: "app/letter/letter.module#LetterModule",
        canActivate: [AuthGuard, RoleGuard],
        canActivateChild: [AuthGuard, RoleGuard],
        canLoad: [AuthGuard, RoleGuard],
        data: { roles: ["genericoRol"] },
      },
      {
        path: "deductible",
        loadChildren: "app/deductible/deductible.module#DeductibleModule",
        canActivate: [AuthGuard, RoleGuard],
        canActivateChild: [AuthGuard, RoleGuard],
        canLoad: [AuthGuard, RoleGuard],
        data: { roles: ["inventarioRol"] },
      },
      {
        path: "migratedsinester",
        loadChildren: "app/migrated-sinester/migrated-sinester.module#MigratedSinesterModule",
        canActivate: [AuthGuard, RoleGuard],
        canActivateChild: [AuthGuard, RoleGuard],
        canLoad: [AuthGuard, RoleGuard],
        data: { roles: ["genericoRol"] },
      },
      {
        path: "migratedclaim",
        loadChildren: "app/migrated-claim/migrated-claim.module#MigratedClaimModule",
        canActivate: [AuthGuard, RoleGuard],
        canActivateChild: [AuthGuard, RoleGuard],
        canLoad: [AuthGuard, RoleGuard],
        data: { roles: ["genericoRol"] },
      },
      {
        path: "notification",
        loadChildren: "app/notification/notification.module#NotificationModule",
        canActivate: [AuthGuard, RoleGuard],
        canActivateChild: [AuthGuard, RoleGuard],
        canLoad: [AuthGuard, RoleGuard],
        data: { roles: ["NotificacionesRol"] },
      },
      {
        path: "precargas-sin-denuncia",
        loadChildren: "app/precarga-sin-denuncia/precarga-sin-denuncia.module#PrecargaSinDenunciaModule",
        canActivate: [AuthGuard, RoleGuard],
        canActivateChild: [AuthGuard, RoleGuard],
        canLoad: [AuthGuard, RoleGuard],
        data: { roles: ["genericoRol"] },
      }
    ],
  },
  {
    path: "nologin",
    loadChildren:
      "app/user-admistrator/user-admistrator.module#UserAdministrationModule",
  },
  {
    path: "login",
    loadChildren: "app/login/login.module#LoginModule",
  },
  { path: "**", pathMatch: "full", redirectTo: "" },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/app.routing.ts